import { getContentfulClient } from './client';
import {
  formatLongDate,
  parseContentfulDate,
  resolveAssetUrl,
  unwrapField,
  unwrapLinkField,
} from './utils';

const CONTENT_TYPE_NEWS = 'news';

async function fetchAllNewsEntries(client) {
  const limit = 100;
  let skip = 0;
  const items = [];
  const assetsById = new Map();
  const order = '-fields.dateOfTheNewsPublication';

  for (;;) {
    const response = await client.getEntries({
      content_type: CONTENT_TYPE_NEWS,
      limit,
      skip,
      order,
      include: 10,
    });
    items.push(...response.items);
    (response.includes?.Asset || []).forEach((a) => {
      assetsById.set(a.sys.id, a);
    });
    if (response.items.length < limit) {
      break;
    }
    skip += limit;
  }
  return { items, assetsById };
}

function mapNewsEntry(entry, assetsById) {
  const f = entry.fields;
  const dateRaw = unwrapField(f.dateOfTheNewsPublication);
  const date = parseContentfulDate(dateRaw);
  const logoUrl = resolveAssetUrl(
    unwrapLinkField(f.newsAgencyLogo),
    assetsById
  );
  const repUrl = resolveAssetUrl(
    unwrapLinkField(f.representativeImage),
    assetsById
  );

  return {
    id: entry.sys.id,
    title: unwrapField(f.articleTitle) || '',
    publication: unwrapField(f.newsAgencyName) || '',
    date: formatLongDate(date),
    link: String(unwrapField(f.urlToTheNews) || '').trim(),
    agencyLogoUrl: logoUrl,
    representativeImageUrl: repUrl,
    mediaType: unwrapField(f.mediaType) || '',
    sortKey: date && !Number.isNaN(date.getTime()) ? date.getTime() : 0,
  };
}

export async function fetchNewsPageItems() {
  const client = getContentfulClient();
  if (!client) {
    throw new Error('Contentful is not configured');
  }

  const { items, assetsById } = await fetchAllNewsEntries(client);
  const rows = items.map((entry) => mapNewsEntry(entry, assetsById));
  return [...rows]
    .sort((a, b) => b.sortKey - a.sortKey)
    .map((row) => ({
      id: row.id,
      title: row.title,
      publication: row.publication,
      date: row.date,
      link: row.link,
      agencyLogoUrl: row.agencyLogoUrl,
      representativeImageUrl: row.representativeImageUrl,
      mediaType: row.mediaType,
    }));
}
